var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{key:_vm.key,staticStyle:{"height":"100%"},attrs:{"id":'charts'+_vm.key}})])
}
var staticRenderFns = []

export { render, staticRenderFns }